module.exports = __webpack_public_path__ + "img/dribbble.f285c735.svg";